// 設定項目検索ユーティリティ
import type { SettingItem } from '../types/index.js';
import { getSettings } from '../state/app-state.js';

/**
 * 設定定義から項目を検索
 */
export function findItemById(itemId: string): { category: any; section: any; item: SettingItem } | null {
    const currentSettings = getSettings();
    if (!currentSettings || !currentSettings.categories) return null;
    for (const category of currentSettings.categories) {
        for (const section of category.sections) {
            const found = section.items.find(item => item.id === itemId);
            if (found) {
                return { category, section, item: found };
            }
        }
    }
    return null;
}

